import { Stack, Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

import { RevenueChartCard } from "./revnue-cart-card";
import { RecentTransactionCard } from "./recent-transaction-card";
import { TopPurchasedCarsTable } from "./top-purchesed-cars-card";
import { dashboard } from "../slice";

const DashboardPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(dashboard());
  }, [dispatch]);

  return (
    <Box sx={{ overflow: "hidden", px: 2 }}>
      <Stack direction="column" alignItems="center" width="100%">
        <Stack
          direction={{ s: "column", md: "row" }}
          justifyContent="space-between"
          width="100%"
          flexWrap="wrap"
          sx={{ gap: 4 }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flex: 1,
              justifyContent: "center",
            }}
          >
            <RevenueChartCard />
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flex: 1,
              justifyContent: "center",
            }}
          >
            <RecentTransactionCard />
          </Box>
        </Stack>

        <Box width="100%" display="flex" justifyContent="center" sx={{ mt: 4 }}>
          <TopPurchasedCarsTable />
        </Box>
      </Stack>
    </Box>
  );
};

export { DashboardPage };
